import { render, staticRenderFns } from "./fangancont.vue?vue&type=template&id=66c8174b&scoped=true&"
import script from "./fangancont.vue?vue&type=script&lang=js&"
export * from "./fangancont.vue?vue&type=script&lang=js&"
import style0 from "./fangancont.vue?vue&type=style&index=0&id=66c8174b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c8174b",
  null
  
)

export default component.exports